import React from "react";
import styles from "./style.module.scss";
// import SharedButton from "@components/severalbrands/sharedButton";
import { useDomainContext } from "@hooks/useDomainContext";
import Form from "@components/shared/form";

const HeroSection = () => {
    const { category } = useDomainContext();
    // const getTitle = () => {
    //     const fallbackStaticTitle =
    //         "Expand Your Client Base with <span style={{ whiteSpace: 'nowrap' }}>High-Intent</span> MVA Leads";
    //     if (!genericPage) {
    //         return fallbackStaticTitle;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-title",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : formattedTitle
    //             ? formattedTitle
    //             : fallbackStaticTitle;
    //     }
    // };
    // const getDescription = () => {
    //     const fallbackStaticDescription =
    //         "Discover how our tailored car accident lead generation solutions can transform your case intake. Get a consultation by completing the form below!";
    //     if (!genericPage) {
    //         return fallbackStaticDescription;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-description",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : fallbackStaticDescription;
    //     }
    // };
    return (
        <div
            className={`${styles["bgStyle"]} ${
                styles[category?.slug as string]
            }`}
        >
            <div className={styles["innerContainerStyle"]}>
                <div className={styles["main-banner"]}>
                    <Form
                        classes={{
                            formClassName: styles["form"],
                            stepTitleClassName: styles["step-title"],
                            stepDescriptionClassName:
                                styles["step-description"],
                            formButtonClassName: styles["form-button"],
                            formFieldClassName: styles["form-field"],
                            formStepInnerClassName: styles["steps-inner"],
                            stepClassName: styles["step-block"],
                            fieldsClassName: {
                                radio: styles["radio-field"],
                                checkbox: styles["checkbox-field"],
                                input: styles["input-field"],
                                multiSelect: styles["multiSelect-field"],
                                select: styles["select-field"],
                                textarea: styles["text-area-field"],
                            },
                            fieldsWrapperClassName: styles["fields-wrapper"],
                            tcpaClassName: styles["tcpa"],
                            labelAsTitleClassName:
                                styles["label-as-step-title"],
                            formProgressbarClassName:
                                styles["progress-background"],
                            fieldErrorMessageClassName: styles["error-style"],
                            formFieldLabelClassName: styles["field-label"],
                            fieldNoteClassName: styles["note-style"],
                        }}
                        backButton={{
                            class: styles["back-button"],
                            label: "",
                        }}
                        colors={{
                            primaryColor: "#EF4F80",
                        }}
                        showProgress
                        showStepNumberOnly
                        searchableMultiSelect
                    />
                </div>
            </div>
        </div>
    );
};
export default HeroSection;
